export class QueryService {
    public static userId = null;

    public static checkUrl(): any {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const lan = urlParams.get('lan');
        const userId = urlParams.get('userId');
        let result = {userId: null, lan: null};
        
        if (userId) {
            this.userId = userId;
            result.userId = userId;
        }

        if (lan) {
            result.lan = `${lan}`;
        }

        return result;
    }
}